import { ButtonClose, ButtonPopup } from "../ui"; // Botones reutilizables
import { PopupModalProps } from "@/types"; // Tipos para el popup

/**
 * Componente PopupModal
 * 
 * Modal genérico que muestra contenido centralizado con fondo semitransparente.
 * Incluye título, contenido y botones de cerrar.
 * 
 * @param {PopupModalProps} props
 * @param {boolean} props.isOpen - Determina si el popup está visible.
 * @param {() => void} props.onClose - Función para cerrar el popup.
 * @param {React.ReactNode} props.children - Contenido del popup.
 * @param {string} [props.className] - Clases CSS adicionales opcionales.
 * @param {string} [props.title] - Título del popup.
 */
const PopupModal: React.FC<PopupModalProps> = ({ isOpen, onClose, children, className, title }) => {
  
  // No renderiza nada si isOpen es false
  if (!isOpen) return null;

  return (
    // Contenedor principal del popup
    // fixed + inset-0: ocupa toda la pantalla
    // flex items-center justify-center: centra el contenido
    // bg-zinc-800 bg-opacity: fondo semitransparente
    // z-50: asegura que esté sobre otros elementos
    <div className={`${className} fixed inset-0 bg-zinc-800 bg-opacity flex items-center justify-center z-50 p-4 overflow-auto`}>
      
      {/* Contenedor interno del contenido del popup */}
      <div
        className={`w-8/12 max-w-full max-h-full bg-white text-black shadow-2xl p-8 overflow-y-auto rounded-lg`}
        style={{ minWidth: '300px' }} // Evita que el popup sea demasiado pequeño en pantallas pequeñas
      >
        
        {/* Botón de cerrar en la esquina superior derecha */}
        <div className="flex justify-end">
          <ButtonClose onClick={onClose} />
        </div>
    
        {/* Título del popup */}
        <h1 className="text-4xl font-bold mb-14 text-center">{title}</h1>
    
        {/* Contenido del popup */}
        <div className="space-y-4">
          {children}
        </div>
    
        {/* Botón inferior para cerrar el popup */}
        <div className="flex justify-center mt-8">
          <ButtonPopup onClick={onClose}>Cerrar</ButtonPopup>
        </div>

      </div>
    </div>
  );
};

export default PopupModal;
